<template>
  <div class="container-fluid">
    <div class="btn-toolbar" role="toolbar">
      <button @click="save" id="comsave" class="btn btn-primary"><font-awesome-icon icon="save"/>&nbsp;Speichern</button><br/><br/>
    </div>
    <div class="row mt-3">
      <div class="col-md">
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>Berichts-Verzeichnis:</label>
              <input id="reportsdir" v-model="config['if.reports.root']" type="text" class="form-control"/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>Berichts-Chrome-Pfad:</label>
              <input id="reportschrome" v-model="config['if.reports.chrome.path']" type="text" class="form-control"/>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md">
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>Dashboard Ausgabe:</label>
              <input id="dashroot" v-model="config['if.proxy.dashboard.root']" type="text" class="form-control"/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>Temporäres Berichtsverz.:</label>
              <input id="reptemp" v-model="config['if.reports.temp']" type="text" class="form-control"/>
              <small id="emailHelp" class="form-text text-muted">(Ben&ouml;tigt Neustart des Connectors).</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/modules/config.js'

export default {
  name: 'ReportsConfig',
  data() {
    return {
      needs: ["if.proxy.print.templates","if.reports.chrome.path","if.reports.root","if.proxy.dashboard.root","if.reports.temp"],
      config: {}
    }
  },
  created: function() {
    console.log('ReportsInit');
    var self = this;
    config.loadcfg(this.needs,this,function(data) {
      self.config = data;
    })
  },
  methods: {
    boolVal: function(val) {
      if (val) {
        var test = String(val);
        return test.startsWith('1') || test.startsWith('1');
      }
      return false;
    },
    save: function() {
      var self = this;
      config.savecfg(this.config,this,function() {
        self.$bvToast.toast('Konfiguration gespeichert',{title:'Allgemein',variant: 'success'});
      })
    }
  }
}
</script>
